import { ProductWithKey } from '../data-management/productsSlice';
import { useSelector } from 'react-redux';
import { RootState } from '../data-management/store';

type UseProductsHookType = () => ProductWithKey[]

export const useProducts: UseProductsHookType = () =>
  useSelector<RootState, ProductWithKey[]>(state => state.products.products);